import { schema } from 'normalizr';

const entitySchema = new schema.Entity('staticPage', undefined, { idAttribute: 'slug' });

export default entitySchema;
